import { useLayoutEffect, useState } from 'react'
import axios from 'axios'
import { useConfig } from '../contexts/ConfigProvider'

const useServiceChecker = () => {
  const [available, setAvailable] = useState(false)
  const [loading, setLoading] = useState(true)
  const config = useConfig()
  const checkC2CServiceAvailability = async () => {
    try {
      const res = await axios.get(`${config.c2cService}/servicecheck`)
      setAvailable(res.status === 200)
      setLoading(false)
    } catch {
      setAvailable(false)
      setLoading(false)
    }
  }
  useLayoutEffect(() => {
    checkC2CServiceAvailability()
  }, [])
  return { available, loading }
}
export default useServiceChecker
